import React, { Fragment } from "react";
// import { withRouter } from "react-router-dom";
import { bool } from "prop-types";
import { useDispatch } from "react-redux";

import Notification from "pages/_components/Notification";
import Image from "pages/_components/Image";
import Head from "pages/_components/Head";
import Button from "pages/_components/Button";
import { goBack, push } from "connected-react-router";
import MainContainer from "pages/_components/MainContainer";
import CustomText from "pages/_components/CustomText/CustomText";
import { Col } from "react-bootstrap";
import * as i18nUtils from "util/i18n";

const StepRegulatoryDataSuccess = ({ isMobile }) => {
    const dispatch = useDispatch();

    const onHeaderBack = () => {
        dispatch(goBack());
    };

    const goNext = () => {
        dispatch(push("/onboarding/stepUser"));
    };

    return (
        <Fragment>
            <Notification scopeToShow="login" />
            {isMobile && <Head title="onboarding.noUser.title" onBack={isMobile && onHeaderBack} hideNavbarInMobile />}
            <MainContainer>
                <Col xs={12} md={8} mdOffset={2}>
                    <h1 className="text-center">
                        <CustomText text={i18nUtils.get("", "¡Ingreso de datos exitoso!")} />
                    </h1>
                </Col>
                <div className="illustration text-center">
                    <Image src="figma/illustrations/onboarding6.svg" className="svg-image logo" />
                </div>
                {/* <Col xs={12} md={8} mdOffset={2}>
                        <div className="bienvenida-alta-persona">Ilustración</div>
                    </Col> */}
                <div className="box box-border-soft">
                    <CustomText
                        text={i18nUtils.get("", "Ya está todo listo para que puedas crear tu usuario y contraseña.")}
                    />
                </div>

                <div className="form-actions">
                    <Button bsStyle="primary" onClick={goNext} label="global.continue" loading={false} block />
                </div>
            </MainContainer>
        </Fragment>
    );
};

StepRegulatoryDataSuccess.propTypes = {
    isMobile: bool.isRequired,
};

export default StepRegulatoryDataSuccess;
// export default withRouter(StepRegulatoryDataSuccess);
